import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface addReceiptVoucherFields {
    client_id?: number;
    client_name?: string;
    order_id?: number;
    order_no?: string;
    voucher_no?: string;
    date?: string;
    value?: number;
    paragraph?: string;
}

// Add receipt voucher state
export interface addReceiptVoucherState {
    fields: addReceiptVoucherFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddReceiptVoucherState: addReceiptVoucherState = {
    fields: {
        date: (new Date()).toISOString().substr(0,10),
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Add receipt voucher slice
export const addReceiptVoucherSlice = createSlice({
    name: 'add_receipt_voucher',
    initialState: initialAddReceiptVoucherState,
    reducers: {
        init: state => initialAddReceiptVoucherState,
        set: ( state, {payload}: PayloadAction<addReceiptVoucherFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setAll: ( state, {payload}: PayloadAction<addReceiptVoucherFields> ) => {
            state.fields = payload
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})